import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 9", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.72667 7.05333L0.946667 4.27333L0 5.21333L3.72667 8.94L11.7267 0.94L10.7867 0L3.72667 7.05333Z" }));
const ForwardRef = forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
